<template>
<div style="padding-left: 15px;">
    <div style="display: none;">{{counter}}</div>
    <div v-for="(node, index) in treeArray" :key="index">
        <div class="tree-content">
            <i
                @click="() => expand(node)"
                :class="{
                    'tree-arrow': true,
                    'has-child': (node.count_children != 0),
                    loading: !node.expand ? node.loading : false,
                    expand: node.expand
                }">
            </i>
            <i
                @click="() => check(node)"
                :class="{
                    'tree-checkbox': true,
                    checked: node.checked,
                    indeterminate: !node.checked ? isAnyoneChecked(node) : false
                }">
            </i>
            <span v-if="registry == 'okved'" class="tree-anchor">{{node.code.replace("2014:", '')}} - {{node.title}}</span>
            <span v-else-if="registry == 'fias'" class="tree-anchor">{{node.title}}</span>
            <span v-else class="tree-anchor">{{node.code}} - {{node.title}}</span>
        </div>
        <tree v-if="node.expand" :treeArray="node.children" :registry="registry" />
    </div>
</div>
</template>

<script>
export default {
    name: 'tree',
    props: ['treeArray', 'registry'],
    data(){
        return {
            expanded: false,
        }
    },
    methods: {
        check(node){
            this.$store.dispatch('search/checkboxClassificator', {registry: this.$props.registry, node})
        },
        expand(node){
            this.$store.dispatch('search/expandClassificator', {registry: this.$props.registry, node})
        },
        isAnyoneChecked(node){
            let isAnyoneChecked = false;
            const find = (arr) => {
                if (arr) {
                    arr.some(e => {
                        if (e.checked == true) {
                            isAnyoneChecked = true
                            return;
                        } else {
                            find(e.children)
                        }
                    })
                }
            }
            find(node.children)
            return isAnyoneChecked
        }
    },
    computed: {
        counter(){
            return this.$store.state.search.counter
        }
    },
}
</script>

<style >
.tree-node {
    white-space: nowrap;
    display: flex;
    flex-direction: column;
    position: relative;
    box-sizing: border-box;
}

.tree-content {
    display: flex;
    align-items: center;
    padding: 1px 0;
    width: 100%;
    box-sizing: border-box;
}

.tree-node:not(.selected) > .tree-content:hover {
    background: #f6f8fb;
}

.tree-node.selected > .tree-content {
    background-color: #e7eef7;
}

.tree-node.disabled > .tree-content:hover {
    background: inherit;
}

.tree-arrow {
    flex-shrink: 0;
    height: 30px;
    cursor: pointer;
    margin-left: 30px;
    width: 0;
}

.tree-arrow.has-child {
    margin-left: 0;
    width: 30px;
    position: relative;
}

.tree-arrow.has-child:after {
    border: 1.5px solid #494646;
    position: absolute;
    border-left: 0;
    border-top: 0;
    left: 9px;
    top: 50%;
    height: 9px;
    width: 9px;
    transform: rotate(-45deg) translateY(-50%) translateX(0);
    transition: transform .25s;
    transform-origin: center;
}

.tree-arrow.expanded.has-child:after {
    transform: rotate(45deg) translateY(-50%) translateX(-5px);
}

.tree-checkbox {
    cursor: pointer;
    flex-shrink: 0;
    position: relative;
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    border: 1px solid #dadada;
    border-radius: 2px;
    background: #fff;
    transition: border-color .25s, background-color .25s;
}

.tree-checkbox:after,
.tree-arrow:after {
    position: absolute;
    display: block;
    content: "";
}

.tree-checkbox.checked {
    background-color: #3a99fc;
    border-color: #218eff;
}

.tree-checkbox.indeterminate {
    background-color: gray;
    border: darkgray;
}

.tree-checkbox.checked:after {
    box-sizing: content-box;
    border: 1.5px solid #fff; /* probably width would be rounded in most cases */
    border-left: 0;
    border-top: 0;
    left: 9px;
    top: 3px;
    height: 15px;
    width: 8px;
    transform: rotate(45deg) scaleY(0);
    transition: transform .25s;
    transform-origin: center;
}

.tree-checkbox.checked:after {
    transform: rotate(45deg) scaleY(1);
}

.tree-checkbox.indeterminate:after {
    background-color: #fff;
    top: 50%;
    left: 20%;
    right: 20%;
    height: 2px;
}

.tree-anchor {
    flex-grow: 2;
    outline: none;
    display: flex;
    text-decoration: none;
    color: #343434;
    vertical-align: top;
    margin-left: 2px;
    line-height: 24px;
    font-size: 14px;
    padding: 3px 6px;
}

.tree-node.selected .tree-anchor {
    outline: none;
}

.tree-node.disabled .tree-anchor {
    color: #989191;
    background: #fff;
    opacity: .6;
    cursor: default;
    outline: none;
}

.tree-input {
    display: block;
    width: 100%;
    height: 24px;
    line-height: 24px;
    outline: none;
    border: 1px solid #3498db;
    padding: 0 4px;
}

.l-fade-enter-active, .l-fade-leave-active {
    transition: opacity .3s, transform .3s;
    transform: translateX(0);
}

.l-fade-enter, .l-fade-leave-to {
    opacity: 0;
    transform: translateX(-2em);
}


.tree--small .tree-anchor {
    line-height: 19px;
}

.tree--small .tree-checkbox {
    width: 23px;
    height: 23px;
}

.tree--small .tree-arrow {
    height: 23px;
}

.tree--small .tree-checkbox.checked:after {
    left: 7px;
    top: 3px;
    height: 11px;
    width: 5px;
}

.tree-node.has-child.loading > .tree-content > .tree-arrow,
.tree-node.has-child.loading > .tree-content > .tree-arrow:after {
    border-radius: 50%;
    width: 15px;
    height: 15px;
    border: 0;
}

.tree-node.has-child.loading > .tree-content > .tree-arrow {
    font-size: 3px;
    position: relative;
    border-top: 1.1em solid rgba(45,45,45, 0.2);
    border-right: 1.1em solid rgba(45,45,45, 0.2);
    border-bottom: 1.1em solid rgba(45,45,45, 0.2);
    border-left: 1.1em solid #2d2d2d;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    left: 5px;
    -webkit-animation: loading 1.1s infinite linear;
    animation: loading 1.1s infinite linear;
    margin-right: 8px;
}

@-webkit-keyframes loading {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes loading {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

.tree {
    overflow: auto;
}

.tree-root,
.tree-children {
    list-style: none;
    padding: 0;
}

.tree > .tree-root,
.tree > .tree-filter-empty {
    padding: 3px;
    box-sizing: border-box;
}

.tree.tree--draggable .tree-node:not(.selected) > .tree-content:hover {
    background: transparent;
}

.drag-above,
.drag-below,
.drag-on {
    position: relative;
    z-index: 1;
}

.drag-on > .tree-content {
    background: #fafcff;
    outline: 1px solid #7baff2;
}

.drag-above > .tree-content::before, .drag-below > .tree-content::after {
    display: block;
    content: '';
    position: absolute;
    height: 8px;
    left: 0;
    right: 0;
    z-index: 2;
    box-sizing: border-box;
    background-color: #3367d6;
    border: 3px solid #3367d6;
    background-clip: padding-box;
    border-bottom-color: transparent;
    border-top-color: transparent;
    border-radius: 0;
}

.drag-above > .tree-content::before {
    top: 0;
    transform: translateY(-50%);
}

.drag-below > .tree-content::after {
    bottom: 0;
    transform: translateY(50%);
}
i.loading {
    font-size: 3px;
    position: relative;
    border-top: 2px solid rgba(45,45,45, 0.2);
    border-right: 2px solid rgba(45,45,45, 0.2);
    border-bottom: 2px solid rgba(45,45,45, 0.2);
    border-left: 2px solid #2d2d2d;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    left: 5px;
    -webkit-animation: loading 1.1s infinite linear;
    animation: loading 1.1s infinite linear;
    margin-right: 8px;
    border-radius: 50px;
    width: 22px !important;
    height: 22px !important
}
i.loading:after {
    content: '';
    display: none;
}
.tree-arrow.has-child:after {
    border: 1.5px solid #494646;
    position: absolute;
    border-left: 0;
    border-top: 0;
    left: 9px;
    top: 50%;
    height: 9px;
    width: 9px;
    transform: rotate(-45deg) translateY(-50%) translateX(0);
    transition: 0;
    transform-origin: center;
}
i.expand:after {
    transform: rotate(45deg) translateY(-50%) translateX(-5px) !important;
}
.tree-checkbox.checked:after {
    box-sizing: content-box;
    border: 1.5px solid #fff;
    border-left: 0;
    border-top: 0;
    left: 3px;
    top: -1px;
    height: 10px;
    width: 6px;
    transition: transform .25s;
    transform-origin: center;
}
</style>